import { monthLabel } from '../model/months'
import type { MonthKey } from '../model/types'

interface StatementLinkProps {
  month: MonthKey
  fileUrl: string
  fileName: string
}

// "Dec 2022 statement". The file name, Bates numbers and all, sits in the tooltip.
export const StatementLink = ({
  month,
  fileUrl,
  fileName,
}: StatementLinkProps) => (
  <a
    href={fileUrl}
    target="_blank"
    rel="noopener noreferrer"
    title={fileName}
    className="cursor-pointer whitespace-nowrap text-xs font-medium text-brand-deep hover:underline"
  >
    {monthLabel(month)} statement
  </a>
)
